import typeCode from 'crypto-js';

// Transport-layer request/response encryption has been removed (relying on TLS + JWT).
// `encrypt`/`decrypt` are retained as thin shims so existing call sites keep working:
//  - `encrypt` builds a deterministic string key — used for duplicate-request detection
//    in ApiManager and for local change-detection comparisons in some views.
//  - `decrypt` normalises a now plain-JSON response into a JSON string, so existing
//    `JSON.parse(decrypt(...))` callers keep working whether axios hands back a string
//    or an already-parsed object.
function encrypt(planeText) {
    return JSON.stringify(planeText)
}

function decrypt(code) {
    if (code === null || code === undefined) return code
    // Response is already plain JSON (axios has parsed objects/arrays; primitives arrive raw).
    // Emit a JSON string so the existing `JSON.parse(decrypt(...))` callers round-trip correctly
    // for every type — including bare-string responses like "User require login with 2fa.".
    return JSON.stringify(code)
}

// Session / localStorage at-rest encryption — a separate concern from transport, retained.
function encryptSession(json) {
    var cipher = typeCode.AES.encrypt(JSON.stringify(json), typeCode.enc.Utf8.parse(process.env.VUE_APP_AES_KEY_SESSION), {
        iv: typeCode.enc.Utf8.parse(process.env.VUE_APP_AES_IV_SESSION),
        mode: typeCode.mode.CBC
        });
    return cipher.toString()
}

function decryptSession(code) {
    var cipher = typeCode.AES.decrypt(code, typeCode.enc.Utf8.parse(process.env.VUE_APP_AES_KEY_SESSION), {
        iv: typeCode.enc.Utf8.parse(process.env.VUE_APP_AES_IV_SESSION),
        mode: typeCode.mode.CBC
        });
    return typeCode.enc.Utf8.stringify(cipher).toString()
}

export {
    encrypt,
    decrypt,
    encryptSession,
    decryptSession,
}
